import { DEFAULT_RENDER_SETTINGS } from '../constants'
import { threeDStudioStore } from '../index'

const setRenderSettings = (patch) => {
  threeDStudioStore.setState(state => ({
    renderSettings: { ...state.renderSettings, ...patch },
  }))
}

/**
 * Sets the free-text prompt describing the final look of the render.
 * @param {string} prompt
 */
export const setPrompt = (prompt) => {
  setRenderSettings({ prompt })
}

/**
 * Sets the chosen render style.
 * @param {{ id: number, slug: string, name: string, tags: string[], image_url: string, asset_id: number }|null} style
 *   - a preset from /api/internal/generator/style_presets; null clears it back to "None"
 */
export const setStyle = (style) => {
  setRenderSettings({ style })
}

/**
 * Resets all render settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    renderSettings: { ...DEFAULT_RENDER_SETTINGS },
  })
}
